import { useDispatch, useSelector } from 'react-redux';
import { cartSlice, StoreState } from '../../../redux';

type BasketEffectReturn = {
  showBasket: () => void;
  hideBasket: () => void;
  basketOpen: boolean;
};

export const useBasketEffect = (): BasketEffectReturn => {
  const dispatch = useDispatch();
  const basketOpen = useSelector(
    (state: StoreState) => state.orders.cart.basketOpen
  );

  const showBasket = (): void => {
    dispatch(cartSlice.actions.showBasket());
  };

  const hideBasket = (): void => {
    dispatch(cartSlice.actions.hideBasket());
  };

  return { showBasket, hideBasket, basketOpen };
};
